import { Injectable, inject } from '@angular/core';
import { MutationOptions } from '@apollo/client/core';
import { Apollo, MutationResult, WatchQueryOptions } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { Observable, map } from 'rxjs';

export enum GraphqlClients {
  auth = 'authClient',
  account = 'accountClient',
  api = 'apiClient',
  approveTvClient = 'approveTvClient',
  supportClient = 'supportClient',
}

@Injectable({
  providedIn: 'root',
})
export class GraphqlService {
  private apollo = inject(Apollo);

  private fetchRequest<T>(request: Observable<MutationResult<T>>): Observable<T> {
    return request.pipe(
      map((res: any) => {
        const key = Object.keys(res.data)[0];
        return res.data[key];
      }),
    );
  }

  makeQuery<T, V = any>(
    client: GraphqlClients,
    query: DocumentNode,
    variables: V | null = null,
    fetchFromCache = false,
  ): Observable<T> {
    const queryOptions: WatchQueryOptions = {
      query,
      variables: variables as any,
    };
    if (fetchFromCache) {
      queryOptions.fetchPolicy = 'cache-and-network';
    }
    const req = this.apollo.use(client).watchQuery<T>(queryOptions).valueChanges;
    return this.fetchRequest<T>(req);
  }

  makeMutation<T, V = any>(
    client: GraphqlClients,
    mutation: DocumentNode,
    variables: V | null = null,
  ): Observable<T> {
    const queryOptions: MutationOptions = {
      mutation,
      variables: variables as any,
    };
    const req = this.apollo.use(client).mutate<T>(queryOptions);
    return this.fetchRequest<T>(req);
  }
}
